/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

export interface ApiSelettivaSetNoAudioLastSelettivaPost$Params {
    /**
     * id della selettiva da caricare
     */
    codiceCorpo?: string;
}

export function apiSelettivaSetNoAudioLastSelettivaPost(
    http: HttpClient,
    rootUrl: string,
    params?: ApiSelettivaSetNoAudioLastSelettivaPost$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<boolean>> {
    const rb = new RequestBuilder(rootUrl, apiSelettivaSetNoAudioLastSelettivaPost.PATH, 'post');
    if (params) {
        rb.query('codiceCorpo', params.codiceCorpo, {});
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return (r as HttpResponse<any>).clone({
                body: String((r as HttpResponse<any>).body) === 'true',
            }) as StrictHttpResponse<boolean>;
        }),
    );
}

apiSelettivaSetNoAudioLastSelettivaPost.PATH = '/api/selettiva/set-no-audio-last-selettiva';
